// Home Page
 import Inputmask from "inputmask";

if (window.location.pathname === '/') {

  Inputmask("99/99/9999").mask(document.getElementById("date_of_birth"));
  Inputmask("999-99-9999").mask(document.getElementById("ssn"));
  Inputmask("(999) 999-9999").mask(document.getElementById("cell_phone"));
  const $shortForm = $(".installment-loan");

  $shortForm.validate({
    errorElement: "div",
    errorClass: "is-invalid",

    highlight: function(element, errorClass) {
      $(element).addClass(errorClass);
    },

    unhighlight: function(element, errorClass) {
      $(element).removeClass(errorClass);
    },

    errorPlacement: function(error, element) {
      error.addClass("invalid-feedback");
      error.insertAfter(element);
    }
  });

  // Remove server-side errors when the user updates the field
  $shortForm.find("input, select").on("input change", function () {
    const $field = $(this);

    $field.removeClass("is-invalid");
    $field.next("small.text-danger").remove();
  });

  $("#ssn").rules("add", {
    required: true,
    validSsn: "full"
  });

  // Validate SSN after the first 3 digits and when fully completed
  $("#ssn").on("input", function() {
    const digits = $(this).val().replace(/\D/g, "");

    if ( digits.length === 3 ||
      digits.length === 5 ||
      digits.length === 9) {
      $(this).valid();
    }
  });
  flatpickr("#date_of_birth", {
    disableMobile: "true",
    dateFormat: "m/d/Y",
    allowInput: true,
    maxDate: new Date().fp_incr(-6574), // set max date to 18 years ago or 6574 days ago
    onReady: function (dateObj, dateStr, instance) {
      const $clear = $(
        '<div class="flatpickr-clear text-center p-2"><button class="btn btn-dark">Clear</button></div>'
      )
        .on("click", () => {
          instance.clear();
          instance.close();
        })
        .appendTo($(instance.calendarContainer));
    }
  });

 }
